import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    // return !!(control && control.invalid);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

export class MyErrorStateMatcherOnlyInvalid implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    // return !!(control && control.invalid);
    return !!(control && control.invalid);
  }
}
